





















import Vue from 'vue';
import { DepotLinkStatus, DepotDto } from '../types/DepotDto';

export default Vue.extend({
  name: 'OctDepotDataTable',
  props: {
    depots: Array,
    loading: Boolean
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('depot_prop_number'),
          value: 'account'
        },
        {
          text: this.$t('depot_prop_email'),
          value: 'email'
        },
        {
          text: this.$t('depot_prop_firstName'),
          value: 'firstName'
        },
        {
          text: this.$t('depot_prop_lastName'),
          value: 'lastName'
        },
        {
          text: this.$t('depot_prop_phone'),
          value: 'phone'
        },
        {
          text: this.$t('depot_prop_lastInteraction'),
          value: 'lastInteraction'
        },
        {
          text: this.$t('depot_prop_status'),
          value: 'linkStatus'
        },
      ]
    };
  },
  methods: {
    getColor (linkStatus: DepotLinkStatus) {
      switch (linkStatus) {
      case 'PENDING':
        return 'orange';
      case 'CONNECTED':
        return 'green';
      case 'DECLINED':
        return 'red';
      case 'INVALID':
        return 'orange darken-3';
      default:
        return 'grey';
      }
    },
    getStatusLabel (linkStatus: DepotLinkStatus) {
      switch (linkStatus) {
      case 'PENDING':
        return this.$t('depot_status_pending');
      case 'CONNECTED':
        return this.$t('depot_status_connected');
      case 'DECLINED':
        return this.$t('depot_status_declined');
      case 'INVALID':
        return this.$t('depot_status_invalid');
      default:
        return this.$t('depot_status_created');
      }
    },
    handleClick (depot: DepotDto) {
      this.$router.push({ name: 'depot', params: { id: depot.id } });
    }
  },
});
